exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nbQmebkMnVa5lRLSohaW5 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  margin: auto;\n  height: inherit;\n}\n._1iB3q8yY5LshdbS72bIm-2 {\n  width: 500px;\n  margin-bottom: 1rem;\n  margin-top: 2rem;\n}\n._1iB3q8yY5LshdbS72bIm-2 > :last-child {\n  padding-top: 32px;\n}\n._5FbYl-C95EUAkcI0sCpGl {\n  height: 1.5rem;\n  margin: 0 0.5rem;\n}\n", ""]);

// exports
exports.locals = {
	"container": "nbQmebkMnVa5lRLSohaW5",
	"form": "_1iB3q8yY5LshdbS72bIm-2",
	"logo": "_5FbYl-C95EUAkcI0sCpGl"
};